import Component from "~/route-containers/partner/store-information.container";
import { partnerLoader } from "~/loaders/partner.loader";
export { partnerLoader as loader };
export default Component;
